var amdi18n={"__root":{"report_button_text":"Send report","report_header":"Dear user,\n\nunfortunately, an unexpected error has occurred. The SkIDentity team is trying to fix it as soon as possible. By submitting the error report attached below, you simplify the analysis and correction of this problem.\n\nIf you want more information on the status of the work on this error, you may include your name, your E-Mail address and optionally additional information.","report_footer":"Best regards\n\nYour SkIDentity Team","your_name":"Your name","your_email":"Your E-Mail address","more_information":"More information","sending_report":"Sending report...","report_sent":"Report sent","report_not_sent":"Report not sent","sessionTimeout_title":"Session abgelaufen","sessionTimeout_desc":"Ihre Session ist abgelaufen, möchten Sie zum Startpunkt zurückkehren?"},"__de":{"report_button_text":"Bericht senden","report_header":"Sehr geehrter Nutzer,\n\nleider ist ein unerwarteter Fehler aufgetreten, den das SkIDentity Team so schnell wie möglich zu beheben versucht. Mit dem Abschicken des unten angehängten Fehlerberichts erleichtern Sie die Analyse und Behebung des Problems.\n\nSollten Sie weitere Informationen über den Status der Arbeiten an diesem Fehler erhalten wollen, so können Sie Ihren Namen, Ihre E-Mail Adresse und gegebenenfalls weitere Informationen angeben.","report_footer":"Mit freundlichen Grüßen\n\nIhr SkIDentity Team","your_name":"Ihr Name","your_email":"Ihre E-Mail Adresse","more_information":"Weitere Informationen","sending_report":"Sende Bericht...","report_sent":"Bericht gesendet","report_not_sent":"Bericht nicht gesendet","sessionTimeout_title":"Session abgelaufen","sessionTimeout_desc":"Ihre Session ist abgelaufen, möchten Sie zum Startpunkt zurückkehren?"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/nls/ErrorView_strings.js
// module id = 160
// module chunks = 1